import BrButton from '@govbr/react-components/lib/BrButton';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { authLogout } from '../../auth/authSlice';
import * as mensagem from '../../common/Mensagens';
import Card from '../../components/Card/Card';
import LoadingGlobal from '../../components/LoadingGlobal/LoadingGlobal';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { PessoaModel } from '../../model/Pessoa';
import {
  selectState
} from './../IdentificacaoPositiva/identificacaoPositivaSlice';
import styles from './TermoDeUso.module.css';
import {
  assinarTermoDeUsoGovBr,
  assinarTermoDeUsoIdPositiva,
  getTermoDeUsoGovBr,
  getTermoDeUsoIdPositiva,
  selectBuscandoTermo,
  selectStateTermoDeUso,
  selectTemTermoAssinado,
  setBuscandoTermo,
  selectVersaoMinimaAceitavel,
} from './termoDeUsoSlice';
import imgErro from '../../assets/img/icone-erro.png';
import imgAlerta from '../../assets/img/icone-alerta.png';
import * as mensagens from '../../common/Mensagens'
import config from '../../envConfig';
import { APPLE_STORE_LINK, GOOGLE_PLAY_LINK } from '../../common/storeUtil';
import { getDecursoPrazo, selectDecursoPrazo } from '../Suporte/SuporteSlice';

const TermoDeUso: React.FC<any> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const stateIdentificacaoPositiva = useAppSelector(selectState);
  const buscandoTermo = useAppSelector(selectBuscandoTermo);
  const stateTermoDeUso = useAppSelector(selectStateTermoDeUso);
  const temVersaoMinimaAceitavel = useAppSelector(selectVersaoMinimaAceitavel);

  const temTermoDeUsoAssinado = useAppSelector(selectTemTermoAssinado);
  const isAuthenticated = auth.isAuthenticated() || authIdPositiva.isAuthenticated();

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  }, [])

  useEffect(() => {
    if (props.comeFromProtectedRoute) {
      if (auth.isAuthenticated()) {
        dispatch(setBuscandoTermo(true));
        dispatch(getTermoDeUsoGovBr(auth.getUser()));
      } else if (authIdPositiva.isAuthenticated()) {
        let pessoa: PessoaModel = {
          nomePessoa: stateIdentificacaoPositiva.nomeCompleto,
          nomeDaMae: stateIdentificacaoPositiva.nomeDaMae,
          dataNascimento: stateIdentificacaoPositiva.dataNascimento,
        };
        dispatch(setBuscandoTermo(true));
        dispatch(getTermoDeUsoIdPositiva(pessoa));
      }
    }
  }, [dispatch, props.comeFromProtectedRoute, stateIdentificacaoPositiva]);

  const assinarTermo = () => {
    if (auth.isAuthenticated()) {
      dispatch(assinarTermoDeUsoGovBr(auth.getUser()));
    } else if (authIdPositiva.isAuthenticated()) {
      let pessoa: PessoaModel = {
        nomePessoa: stateIdentificacaoPositiva.nomeCompleto,
        nomeDaMae: stateIdentificacaoPositiva.nomeDaMae,
        dataNascimento: stateIdentificacaoPositiva.dataNascimento,
      };
      dispatch(assinarTermoDeUsoIdPositiva(pessoa));
    } else {
      dispatch(authLogout({ history }));
      history.push('/home');
    }
  };

  const voltar = () => {
    if (authIdPositiva.isAuthenticated() || !props.comeFromProtectedRoute) {
      if (!temTermoDeUsoAssinado && authIdPositiva.isAuthenticated()) {
        dispatch(authLogout({ history, keepIdPositiva: false }));
      }
      return history.push('/home');
    }
    dispatch(authLogout({ history, keepIdPositiva: true }));
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const fecharMensagemAtualizacaoApp = () => {
    if (config.isCordova) {
      if (config.device.platform === 'IOS') {
        window.open(APPLE_STORE_LINK, '_system', 'location=yes');
      } else {
        window.open(GOOGLE_PLAY_LINK, '_system', 'location=yes');
      }
    }

    dispatch(authLogout({ history }));
  };

  if (buscandoTermo) {
    return <LoadingGlobal/>;
  }

  return (
    <MainContainer
      navSeparator
      navHideArrow={props.comeFromProtectedRoute}
      titleBarraAuxiliar="Termo de uso"
      userNav={false}
      padraoInicial={true}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed={false}>
      <div className={styles.container}>
        {(!isAuthenticated || (isAuthenticated && temTermoDeUsoAssinado !== undefined)) &&
          <Card className={styles.card}>
            <span className={styles.textTitle}>
              Aviso de Privacidade do aplicativo ou site "CADASTRO ÚNICO"
            </span>
            <br />

            <span className={styles.subTitle}>1. Quais informações estão presentes neste documento?</span>
            <span>
              Neste <u>Termo de Uso</u>, o usuário do serviço Aplicativo e site do CADASTRO ÚNICO, encontrará informações sobre: o funcionamento do serviço e as regras aplicáveis a ele;
              o arcabouço legal relacionado à prestação do serviço; as responsabilidades do usuário ao utilizar o serviço; as responsabilidades da administração pública ao prover o serviço;
              informações para contato, caso exista alguma dúvida ou seja necessário atualizar informações; e o foro responsável por eventuais reclamações caso questões deste <u>Termo de Uso </u>
              tenham sido violadas.<p />
            </span>
            <p />

            <span className={styles.subTitle}>2. Aceitação do Termo de Uso e Política de Privacidade </span>
            <span>
              Ao utilizar os serviços, o usuário confirma que leu e compreendeu os Termos e Políticas
              aplicáveis ao serviço Aplicativo e site do CADASTRO ÚNICO e concorda em ficar vinculado a
              eles.<p />
            </span>
            <p />

            <span className={styles.subTitle}>3. Definições</span>
            <span>
              Para melhor compreensão deste documento, neste Termo de Uso e Política de Privacidade,
              consideram-se:<p />
            </span>
            <span>
              <strong>Dado pessoal:</strong> informação relacionada a pessoa natural identificada ou identificável.<p />

              <strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais que são objeto de tratamento.<p />

              <strong>Controlador:</strong> pessoa natural ou jurídica, de direito público ou privado, a quem competem as
              decisões referentes ao tratamento de dados pessoais.<p />

              <strong>Operador:</strong> pessoa natural ou jurídica, de direito público ou privado, que realiza o tratamento
              de dados pessoais em nome do controlador.<p />

              <strong>Encarregado:</strong> pessoa indicada pelo controlador e operador para atuar como canal de
              comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção
              de Dados (ANPD).<p />

              <strong>Agentes de tratamento:</strong> o controlador e o operador.<p />

              <strong>Tratamento:</strong> toda operação realizada com dados pessoais, como as que se referem a coleta,
              produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição,
              processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da
              informação, modificação, comunicação, transferência, difusão ou extração.<p />

              <strong>Uso compartilhado de dados:</strong> comunicação, difusão, transferência internacional, interconexão
              de dados pessoais ou tratamento compartilhado de bancos de dados pessoais por órgãos e
              entidades públicos no cumprimento de suas competências legais, ou entre esses e entes
              privados, reciprocamente, com autorização específica, para uma ou mais modalidades de
              tratamento permitidas por esses entes públicos, ou entres privados.<p />

              <strong>Autoridade nacional:</strong> órgão da administração pública responsável por zelar, implementar e
              fiscalizar o cumprimento desta Lei em todo o território nacional.<p />

              <strong>Agente público:</strong> Todo aquele que exerce, ainda que transitoriamente ou sem remuneração,
              por eleição, nomeação, designação, contratação ou qualquer outra forma de investidura ou
              vínculo, mandato, cargo, emprego ou função nos órgãos e entidades da Administração Pública,
              direta e indireta.<p />

              <strong>Agentes de Estado:</strong> inclui órgãos e entidades da Administração pública além dos seus agentes
              públicos.<p />

              <strong>Sítios e aplicativos:</strong> sítios e aplicativos por meio dos quais o usuário acessa os serviços e
              conteúdos disponibilizados.<p />

              <strong>Terceiro:</strong> Pessoa ou entidade que não participa diretamente em um contrato, em um ato
              jurídico ou em um negócio, ou que, para além das partes envolvidas, pode ter interesse num
              processo jurídico.<p />

              <strong>Usuários (ou "Usuário", quando individualmente considerado):</strong> todas as pessoas naturais que
              utilizarem o serviço Aplicativo e site do CADASTRO ÚNICO.<p />

              <strong>Família:</strong> a unidade nuclear composta por uma ou mais pessoas, eventualmente ampliada por
              outras que contribuam para o rendimento ou tenham suas despesas atendidas por ela, todas
              moradoras em um mesmo domicílio.<p />

              <strong>Domicílio:</strong> o local que serve de moradia à família.<p />

              <strong>Morador:</strong> a pessoa que: a) tem o domicílio como local habitual de residência e nele reside na
              data da entrevista; b) embora ausente na data da entrevista, tem o domicílio como residência
              habitual; ou c) está internada ou abrigada em estabelecimentos de saúde, Instituições de
              Longa Permanência para Idosos, equipamentos que prestam Serviços de Acolhimento,
              instituições de privação de liberdade, ou em outros estabelecimentos similares, por um
              período igual ou inferior a 12 meses, tomando como referência a data da entrevista.<p />

              <strong>Responsável Familiar (RF):</strong> um dos componentes da família morador do domicílio, com idade
              mínima de 16 anos e, preferencialmente, do sexo feminino, responsável por prestar as
              informações ao CadÚnico em nome da família.<p />

              <strong>Cadastro atualizado:</strong> o registro familiar que, no prazo máximo de dois anos contados da data
              de sua inclusão ou última atualização no CadÚnico, foi objeto de alteração de informações
              específicas.<p />

              <strong>Solicitação de cadastramento:</strong> o registro familiar iniciado pelo cidadão e que deverá ser
              complementado junto à gestão municipal no prazo de {decursoPrazo} dias.<p />
            </span>
            <p />

            <span className={styles.subTitle}>4. Descrição do serviço</span>
            <span>
              O Cadastro Único para Programas Sociais do Governo Federal (Cadastro Único) é um
              instrumento que identifica e caracteriza as famílias de baixa renda, permitindo que o governo
              conheça melhor a realidade socioeconômica dessa população. Nele são registradas
              informações como: características do domicílio, identificação de cada pessoa, escolaridade,
              situação de trabalho e renda, entre outras.<p />

              As famílias inscritas no Cadastro Único podem participar de diferentes programas sociais,
              {/* como o Programa Bolsa Família, a Tarifa Social de Energia Elétrica, o Benefício de Prestação */}
              como o Programa Bolsa Família, o Benefício de Prestação
              Continuada, entre outros. Também podem participar da seleção de beneficiários de programas
              ofertados pelos governos estaduais e municipais. Por isso, o Cadastro Único funciona como
              uma porta de entrada para as famílias acessarem diversas políticas públicas. <p />

              A execução do Cadastro Único é de responsabilidade compartilhada entre o governo federal,
              os estados, os municípios e o Distrito Federal. Em nível federal, o Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome é o
              gestor responsável, e a Dataprev S.A. é responsável pelo desenvolvimento e manutenção do
              aplicativo e site CADASTRO ÚNICO.<p />

              O aplicativo e site CADASTRO ÚNICO oferece os seguintes serviços:<p />

              <strong>Consulta por CPF </strong><br/>
              Permite consultar se uma pessoa está cadastrada no Cadastro Único a partir do CPF e
              data de nascimento informados. A consulta é feita apenas se o CPF e data de nascimento
              informados estiverem iguais aos dados da Receita Federal.
              Essa consulta considera dados registrados no Sistema de Cadastro Único até o dia útil anterior. <p/>

              <strong>Consulta simples</strong><br/>
              Concede acesso às informações resumidas do cadastro da família do usuário, como o NIS dos
              integrantes, a data de cadastramento e da última atualização cadastral, a faixa de renda
              familiar, entre outras. Essa consulta considera dados registrados no Sistema de Cadastro Único
              até o dia útil anterior.<p/>

              <strong>Consulta completa</strong><br/>
              Concede acesso às informações completas do cadastro da família do usuário, como dados de
              endereço, domicílio, características da família, Responsável Familiar, integrantes, entre outras.<p />

              <strong>Comprovante de Cadastro</strong><br/>
              Permite emitir o comprovante de cadastramento, que serve para atestar que o usuário está
              cadastrado no Cadastro Único.<p />

              {/* <strong>Atualização cadastral por confirmação</strong><br/>
              Permite que o usuário confirme que os dados já cadastrados para a família no Cadastro Único
              permanecem atuais, ou seja, não houve qualquer mudança de endereço, composição familiar, renda ou
              escolaridade para as pessoas que integram a família.<p />

              Também é possível incluir ou alterar o número de telefone de contato ou o endereço de e-mail da
              pessoa RF, sem necessidade de ir a um posto de atendimento do Cadastro Único.<p />

              Ao incluir ou alterar telefone ou e-mail, o usuário tem a opção de autorizar ou não o recebimento
              de mensagens. Caso o envio de mensagens seja autorizado, o usuário deverá concordar com o
              <strong> Termo de Autorização para envio de mensagens (via celular e e-mail)</strong>.<p />

              Caso alguma outra informação esteja diferente daquela apresentada na tela, o(a)
              Responsável Familiar (RF) deverá então ir até um posto de atendimento do Cadastro Único no
              seu município.<p />*/}

              <strong>Solicitação de cadastramento</strong><br />
              Essa é a primeira etapa para o usuário entrar no Cadastro Único, por meio do aplicativo. Para
              realizar a solicitação de cadastramento da sua família, é preciso que o usuário seja o(a) Responsável Familiar e
              que faça login pela plataforma do Governo Federal chamada “gov.br”. Caso não seja possível
              realizar a solicitação de cadastramento por meio do aplicativo, o(a) Responsável Familiar deverá ir até
              um CRAS ou posto de atendimento no município. <p />

              Após finalizar a solicitação de cadastramento, o(a) Responsável Familiar (RF) tem {decursoPrazo} dias
              para ir ao CRAS ou posto de atendimento do Cadastro Único completar o cadastro.<p />

              <strong>Meus Benefícios</strong><br />
              Permite que o usuário confira quais são os benefícios do governo federal que sua família
              recebe e ter informações de como acessar os programas oferecidos pelo governo federal para
              as famílias cadastradas. No momento, é possível consultar o recebimento dos seguintes benefícios:
              Programa Bolsa Família; Benefício de Prestação Continuada (BPC); Auxílio Inclusão.<p />

              <strong>Postos de atendimento</strong><br />
              Permite que o usuário consulte os postos de atendimento do Cadastro Único que ficam mais
              próximos de onde ele está.<p />

              <strong>Validar Comprovante</strong><br />
              Permite que os órgãos responsáveis pelos programas sociais que usam o Cadastro Único
              validem o comprovante de cadastramento emitido pelo aplicativo Cadastro Único. <p />
            </span>
            <p />

            <span className={styles.subTitle}>5. Agentes de tratamento</span>
            <span className={styles.subTitle}>5.1. A quem compete as decisões referentes ao tratamento de dados pessoais realizado
              no serviço Aplicativo e site do CADASTRO ÚNICO (Controlador)?</span>
            <span>
              Para o serviço Aplicativo e site do CADASTRO ÚNICO, as decisões referentes ao tratamento de
              dados pessoais são de responsabilidade do <strong>MINISTÉRIO DO DESENVOLVIMENTO E ASSISTÊNCIA SOCIAL, FAMÍLIA E COMBATE À FOME</strong>. Endereço: Esplanada
              dos Ministérios, Bloco A - Zona Cívico-Administrativa - Brasília/DF - CEP 70054-906. Telefone:
              121.
            </span>
            <p />

            <span className={styles.subTitle}>5.2. Quem realiza o tratamento de dados (Operador)?</span>
            <span>
              Para o serviço Aplicativo e site do CADASTRO ÚNICO, quem realiza o tratamento de dados
              pessoais em nome do controlador é o operador <strong>EMPRESA DE TECNOLOGIA E INFORMAÇÕES
              DA PREVIDÊNCIA – DATAPREV</strong> S.A. Endereço: SAS Quadra, 01, Bloco E/F. Brasília - DF. CEP:
              70.070-931.
            </span>
            <p />

            <span className={styles.subTitle}>5.3. Quem é o responsável por atuar como canal de comunicação entre o controlador, os
              titulares dos dados e a Autoridade Nacional de Proteção de Dados (Encarregado)?</span>
            <span>
              Para o serviço Aplicativo e site do CADASTRO ÚNICO, que é responsável por atuar como canal
              de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de
              Proteção de Dados é o encarregado Eduardo Flores Vieira – Ouvidor-Geral do Ministério da
              Cidadania. E-mail: <a target="_blank" rel="noreferrer" href="mailto:protecaodedados@cidadania.gov.br">protecaodedados@cidadania.gov.br</a> Telefone: 121.<p />
            </span>
            <p />

            <span className={styles.subTitle}>6. Quais são as leis e normativos aplicáveis a esse Termo?</span>
            <span>
              Lei nº 12.965, de 23 de abril de 2014 - Marco Civil da Internet – Estabelece princípios,
              garantias, direitos e deveres para o uso da Internet no Brasil.<p />

              Lei nº 12.527, de 18 de novembro de 2011 - Lei de Acesso à Informação – Regula o acesso a
              informações previsto na Constituição Federal.<p />

              Lei nº 13.460, de 26 de junho de 2017 - Dispõe sobre participação, proteção e defesa dos
              direitos do usuário dos serviços públicos da administração pública.<p />

              Lei nº 13.709, de 14 de agosto de 2018 - Dispõe sobre o tratamento de dados pessoais,
              inclusive nos meios digitais, por pessoa natural ou por pessoa jurídica de direito público ou
              privado, com o objetivo de proteger os direitos fundamentais de liberdade e de privacidade e
              o livre desenvolvimento da personalidade da pessoa natural.<p />

              Decreto nº 8.777, de 11 de maio de 2016 - Institui a Política de Dados Abertos do Poder
              Executivo federal.<p />

              Decreto nº 7.724, de 16 de maio de 2012 - Regulamenta a Lei no 12.527, de 18 de novembro
              de 2011 (Lei de Acesso à Informação), que dispõe sobre o acesso a informações previsto na
              Constituição Decreto nº 10.046, de 09 de outubro de 2019 - Dispõe sobre a governança no
              compartilhamento de dados no âmbito da administração pública federal e institui o Cadastro
              Base do Cidadão e o Comitê Central de Governança de Dados.<p />
            </span>
            <p />

            <span className={styles.subTitle}>7. Quais são as leis e normativos aplicáveis a esse Serviço?</span>
            <span>
              Lei nº 8.742, de 7 de dezembro de 1993 - Dispõe sobre a organização da Assistência Social e dá
              outras providências. Art. 6º-F – institui o Cadastro Único (incluído pela Lei nº 14.284, de 2021).<p />

              Decreto nº 11.016, de 29 de março de 2022 - Dispõe sobre o Cadastro Único para Programas
              Sociais do Governo Federal e dá outras providências.<p />

              Portaria MDS nº 177, de 16 de junho de 2011 - Define procedimentos para a gestão do
              Cadastro Único para Programas Sociais do Governo Federal e dá outras providências.<p />

              Portaria MDS nº 10, de 30 de janeiro de 2012 - Disciplina critérios e procedimentos para a
              disponibilização e a utilização de informações contidas no Cadastro Único.<p />

              Portaria MDS nº 501, de 29 de novembro de 2017 - Disciplina o processo de uso do Cadastro
              Único para Programas Sociais do Governo Federal por órgãos e entidades federais para seleção
              de beneficiários de políticas e programas sociais voltados ao atendimento às famílias de baixa
              renda.<p />

              Portaria MDS nº 502, de 29 de novembro de 2017 - Institui a Política de Controle de Acesso aos
              dados do Cadastro Único para Programas Sociais.<p />
            </span>
            <p />

            <span className={styles.subTitle}>8. Quais são os direitos do usuário do serviço? </span>
            <span>
              O usuário do serviço possui os seguintes direitos, conferidos pela Lei de Proteção de Dados
              Pessoais:<p />

              <strong>- Direito de confirmação e acesso (Art. 18, I e II):</strong> é o direito do usuário de obter do serviço a
              confirmação de que os dados pessoais que lhe digam respeito são ou não objeto de
              tratamento e, se for esse o caso, o direito de acessar os seus dados pessoais.<p />

              <strong>- Direito de retificação (Art. 18, III): </strong> é o direito de solicitar a correção de dados incompletos,
              inexatos ou desatualizados.<p />

              <strong>- Direito à limitação do tratamento dos dados (Art. 18, IV):</strong> é o direito do usuário de limitar o
              tratamento de seus dados pessoais, podendo exigir a eliminação de dados desnecessários,
              excessivos ou tratados em desconformidade com o disposto na Lei Geral de Proteção de
              Dados.<p />

              <strong>- Direito de oposição (Art. 18, § 2º):</strong> é o direito do usuário de, a qualquer momento, se opor
              ao tratamento de dados por motivos relacionados com a sua situação particular, com
              fundamento em uma das hipóteses de dispensa de consentimento ou em caso de
              descumprimento ao disposto na Lei Geral de Proteção de Dados.<p />

              <strong>- Direito de não ser submetido a decisões automatizadas (Art. 20, LGPD):</strong> o titular dos dados
              tem direito a solicitar a revisão de decisões tomadas unicamente com base em tratamento
              automatizado de dados pessoais que afetem seus interesses, incluídas as decisões destinadas a
              definir o seu perfil pessoal, profissional, de consumo e de crédito ou os aspectos de sua
              personalidade.<p />
            </span>
            <p />

            <span className={styles.subTitle}>9. Quais são as obrigações dos usuários que utilizam o serviço? </span>
            <span>
              O usuário se responsabiliza pela precisão e veracidade dos dados informados e reconhece que
              a inconsistência destes poderá implicar a impossibilidade de se utilizar o serviço Aplicativo e
              site do CADASTRO ÚNICO.<p />

              O usuário se compromete a procurar o posto de atendimento do Cadastro Único do município
              em que reside para finalizar a solicitação de cadastramento da família em até {decursoPrazo} dias.<p />

              O usuário é responsável por procurar a gestão municipal para atualizar o cadastro de sua
              família sempre que houver mudanças em relação às informações prestadas ou, no máximo,
              em até dois anos da data da entrevista.<p />

              O login e senha só poderão ser utilizados pelo usuário cadastrado. Ele se compromete em
              manter o sigilo da senha, que é pessoal e intransferível, não sendo possível, em qualquer
              hipótese, a alegação de uso indevido, após o ato de compartilhamento.<p />

              O Usuário é responsável pela reparação de todos e quaisquer danos, diretos ou indiretos
              (inclusive decorrentes de violação de quaisquer direitos de outros usuários, de terceiros,
              inclusive direitos de propriedade intelectual, de sigilo e de personalidade), que sejam causados
              à Administração Pública, a qualquer outro Usuário, ou, ainda, a qualquer terceiro, inclusive em
              virtude do descumprimento do disposto nestes Termos de Uso e Política de Privacidade ou de
              qualquer ato praticado a partir de seu acesso ao serviço.<p />

              O Órgão não poderá ser responsabilizado pelos seguintes fatos:<p />

              <strong>a.</strong> Equipamento infectado ou invadido por atacantes;<p />
              <strong>b.</strong> Equipamento avariado no momento do consumo de serviços;<p />
              <strong>c.</strong> Proteção do computador;<p />
              <strong>d.</strong> Proteção das informações baseadas nos computadores dos usuários;<p />
              <strong>e.</strong> Abuso de uso dos computadores dos usuários;<p />
              <strong>f.</strong> Monitoração clandestina do computador dos usuários;<p />
              <strong>g.</strong> Vulnerabilidades ou instabilidades existentes nos sistemas dos usuários;<p />
              <strong>h.</strong> Perímetro inseguro;<p />

              Em nenhuma hipótese, a Administração Pública Federal será responsável pela instalação no
              equipamento do Usuário ou de terceiros, de códigos maliciosos (vírus, trojans, malware,
              worm, bot, backdoor, spyware, rootkit, ou de quaisquer outros que venham a ser criados), em
              decorrência da navegação na Internet pelo Usuário.<p />
            </span>
            <p />

            <span className={styles.subTitle}>10. Quais são as responsabilidades da administração pública com meus dados? </span>
            <span>
              A Administração Pública se compromete a cumprir todas as legislações inerentes ao uso
              correto dos dados pessoais do cidadão de forma a preservar a privacidade dos dados utilizados
              no serviço, bem como a garantir todos os direitos e garantias legais dos titulares dos dados. Ela
              também se obriga a promover, independentemente de requerimentos, a divulgação em local
              de fácil acesso, no âmbito de suas competências, de informações de interesse coletivo ou geral
              por eles produzidas ou custodiadas. É de responsabilidade da Administração Pública
              implementar controles de segurança para proteção dos dados pessoais dos titulares.<p />

              A Administração Pública poderá, quanto às ordens judiciais de pedido das informações,
              compartilhar informações necessárias para investigações ou tomar medidas relacionadas a
              atividades ilegais, suspeitas de fraude ou ameaças potenciais contra pessoas, bens ou sistemas
              que sustentam o Serviço ou de outra forma necessária para cumprir com nossas obrigações
              legais. Caso ocorra, a Administração Pública notificará os titulares dos dados, salvo quando o
              processo estiver em segredo de justiça.<p />
            </span>
            <p />

            <span className={styles.subTitle}>11. Este Termo de Uso pode ser alterado?</span>
            <span>
              A presente versão desta Política de Privacidade foi atualizada pela última vez em: 21/07/2022.<p />

              O editor se reserva o direito de modificar, a qualquer momento as presentes normas,
              especialmente para adaptá-las às evoluções do serviço Aplicativo e site do CADASTRO ÚNICO,
              seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação
              daquelas já existentes.<p />

              O usuário será explicitamente notificado em caso de alteração deste Termo de Uso.<p />
            </span>
            <p />

            <span className={styles.subTitle}>12. Qual o foro aplicável caso o usuário queira realizar alguma reclamação?</span>
            <span>
              Este Termo será regido pela legislação brasileira. Qualquer reclamação ou controvérsia com
              base neste Termo será dirimida exclusivamente pela Comarca de Brasília, DF.<p />

              Sem prejuízo de qualquer outra via de recurso administrativo ou judicial, todos os titulares de
              dados têm direito a apresentar reclamação à Autoridade Nacional de Proteção de Dados.<p />
            </span>
            <p /><p />

            <span className={styles.textTitle}>
              POLÍTICA DE PRIVACIDADE
            </span>
            <br />

            <span>
              Na Política de Privacidade, o usuário do serviço Aplicativo e site do CADASTRO ÚNICO
              encontrará informações sobre: qual o tratamento dos dados pessoais realizados, de forma
              automatizada ou não, e a sua finalidade; os dados pessoais dos usuários necessários para a
              prestação do serviço; a forma como eles são coletados; se há o compartilhamento de dados
              com terceiros; e quais as medidas de segurança implementadas para proteger os dados.<p />
            </span>
            <p />
            <span>
              Esta Política de Privacidade foi elaborada em conformidade com a Lei Federal nº 12.965 de 23
              de abril de 2014 (Marco Civil da Internet) e com a Lei Federal nº 13.709, de 14 de agosto de
              2018 (Lei de Proteção de Dados Pessoais).<p />

              Esta Política de Privacidade poderá ser atualizada em decorrência de eventual atualização
              normativa, razão pela qual se convida o usuário a consultar periodicamente esta seção.<p />

              O aplicativo e site se compromete a cumprir as normas previstas na Lei Geral de Proteção de
              Dados (LGPD), e respeitar os princípios dispostos no Art. 6º:<p />

              I - <strong>finalidade:</strong> realização do tratamento para propósitos legítimos, específicos, explícitos e
              informados ao titular, sem possibilidade de tratamento posterior de forma incompatível com
              essas finalidades;<p />

              II - <strong>adequação:</strong> compatibilidade do tratamento com as finalidades informadas ao titular, de
              acordo com o contexto do tratamento;<p />

              III - <strong>necessidade:</strong> limitação do tratamento ao mínimo necessário para a realização de suas
              finalidades, com abrangência dos dados pertinentes, proporcionais e não excessivos em
              relação às finalidades do tratamento de dados;<p />

              IV - <strong>livre acesso:</strong> garantia, aos titulares, de consulta facilitada e gratuita sobre a forma e a
              duração do tratamento, bem como sobre a integralidade de seus dados pessoais;<p />

              V - <strong>qualidade dos dados:</strong> garantia, aos titulares, de exatidão, clareza, relevância e atualização
              dos dados, de acordo com a necessidade e para o cumprimento da finalidade de seu
              tratamento;<p />

              VI - <strong>transparência:</strong> garantia, aos titulares, de informações claras, precisas e facilmente
              acessíveis sobre a realização do tratamento e os respectivos agentes de tratamento,
              observados os segredos comercial e industrial;<p />

              VII - <strong>segurança:</strong> utilização de medidas técnicas e administrativas aptas a proteger os dados
              pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda,
              alteração, comunicação ou difusão;<p />

              VIII - <strong>prevenção:</strong> adoção de medidas para prevenir a ocorrência de danos em virtude do
              tratamento de dados pessoais;<p />

              IX - <strong>não discriminação:</strong> impossibilidade de realização do tratamento para fins discriminatórios
              ilícitos ou abusivos;<p />

              X - <strong>responsabilização e prestação de contas:</strong> demonstração, pelo agente, da adoção de
              medidas eficazes e capazes de comprovar a observância e o cumprimento das normas de
              proteção de dados pessoais e, inclusive, da eficácia dessas medidas.<p />
            </span><p />

            <span className={styles.textTitle}>
              Quais dados pessoais são tratados pelo serviço?
            </span>

            <span>
              Para a utilização de determinadas funcionalidades do serviço pelo usuário, é necessário o
              tratamento dos seguintes dados pessoais:
            </span><p />
            <span>
              <ul className={styles.list}>
                <li>Dados de identificação do usuário</li>
                <li>Documentação do usuário</li>
                <li>Endereço de residência</li>
                <li>Dados de contato</li>
                <li>Dados de identificação dos integrantes da família, inclusive crianças e adolescentes</li>
                <li>Documentação dos integrantes da família</li>
                <li>Características da família</li>
                <li>Escolaridade dos integrantes da família</li>
                <li>Dados de trabalho e remuneração dos integrantes da família, inclusive crianças e adolescentes</li>
                <li>Características do domicílio</li>
                <li>Pertencimento da família a Grupos Populacionais Tradicionais e Específicos</li>
                <li>Participação do usuário ou da família em benefícios e serviços sociais</li>
              </ul>
            </span>
            <p />
            <span>Também podem ser tratados os seguintes dados pessoais sensíveis:</span><p />
            <span>
              <ul className={styles.list}>
                <li>dados que revelam origem racial ou étnica: cor ou raça e pertencimento a grupos populacionais tradicionais e específicos;</li>
                <li>dado que revela convicção religiosa: - pertencimento a grupos populacionais tradicionais e específicos;</li>
                <li>dado que revela filiação a organização de caráter religioso: - pertencimento a grupos populacionais tradicionais e específicos; e</li>
                <li>dado referente à saúde: - informações de pessoas com deficiência na família.</li>
                <li>dados de identificação dos integrantes da família, inclusive crianças e adolescentes</li>
              </ul>
            </span>
            <p />
            <span>Para manter o funcionamento do aplicativo ou site durante o uso, são temporariamente armazenadas no dispositivo de acesso as seguintes informações:</span>
            <p />
            <span>
              <ul className={styles.list}>
                <li>Um identificador gerado pela conta gov.br, chamado de token de sessão;</li>
                <li>Um identificador de autorização gerado pelo “CADASTRO ÚNICO”;</li>
                <li>Nome completo;</li>
                <li>CPF;</li>
                <li>Nome da mãe; e</li>
                <li>Data de nascimento.</li>
              </ul>
            </span><p />

            <span>Para permitir a disponibilização do “CADASTRO ÚNICO”, e atendendo aos requisitos das lojas de aplicativos, poderá ocorrer a coleta das seguintes informações:</span>
            <p />
            <span>
              <ul className={styles.list}>
                <li>Modelo do equipamento que está baixando o aplicativo;</li>
                <li>Sistema operacional;</li>
                <li>Versão do Navegador; e</li>
                <li>Localização</li>
              </ul>
            </span><p />

            <span className={styles.textTitle}>
              Como os dados são coletados?
            </span><p />
            <span>
              Os dados pessoais do Cadastro Único são coletados por meio de entrevista à gestão municipal
              do Cadastro Único ou informado pelo usuário via aplicativo ou site.<p />

              Os dados sobre participação do cidadão ou da família em benefícios e serviços sociais é obtida
              por meio de cruzamento dos dados do Cadastro Único com as bases de dados de benefícios
              sociais.<p />

              Informações específicas sobre modelo do dispositivo, sistema operacional (entre elas
              configuração, navegadores) e identificadores do dispositivo (localização, dentre outros) são
              obtidos por meio do dispositivo de acesso, após autorização do usuário.<p />
            </span><p /><p />

            <span className={styles.textTitle}>
              Para que fim utilizamos seus dados?
            </span><p />
            <span>
              Os dados pessoais do Cadastro Único são necessários para identificação e caracterização do
              usuário, de sua família e dos integrantes da família no Cadastro Único, tendo como finalidade
              formulação e gestão de políticas públicas e realização de estudos e pesquisas.<p />

              Os dados sobre participação do cidadão ou da família em benefícios e serviços sociais são
              utilizados para garantir transparência ao usuário e sua família quanto ao recebimento de
              benefícios sociais.<p />

              Os dados específicos a respeito do dispositivo visam à melhoria contínua dos processos e
              serviços prestados.<p />
            </span><p /><p />

            <span className={styles.textTitle}>
              Qual o tratamento realizado com os dados pessoais?
            </span><p />
            <span>
              Os dados pessoais do aplicativo e site Cadastro Único podem passar pelos seguintes
              tratamentos, como por exemplo: coleta, armazenamento, avaliação, cruzamento, comparação,
              classificação, processamento, transferência, controle e utilização para formulação e gestão de
              políticas públicas e realização de estudos e pesquisas.<p />
            </span><p /><p />

            <span className={styles.textTitle}>
              Os dados pessoais utilizados no serviço são compartilhados?
            </span><p />
            <span>
              Os dados pessoais do usuário podem ser compartilhados nas seguintes hipóteses:
            </span><p />
            <span>
              <ul className={styles.list}>
                <li>Para órgãos e entidades da administração pública para o tratamento e uso compartilhado de dados necessários
                  à execução de políticas públicas, mediante cumprimento dos procedimentos de cessão de dados do Cadastro Único; </li>
                <li>Para instituições de pesquisa, ou pesquisadores individuais, para a realização de estudos e pesquisas,
                  mediante cumprimento dos procedimentos de cessão de dados do Cadastro Único; </li>
                <li>Por solicitação do poder judiciário e Ministério Público; e</li>
                <li>Para atividades de investigação e repressão de infrações penais, mediante solicitação formal; </li>
                <li>Para órgãos de controle, internos e externos, mediante solicitação formal.</li>
              </ul><p />
            </span><p /><p />

            <span className={styles.textTitle}>
              Segurança no tratamento dos dados pessoais do usuário
            </span><p />
            <span>
              Os seus dados são tratados nos Centros de Dados (Data Centers) próprios da Dataprev, em
              território nacional.<p />

              Os Centros de Dados (Data Centers) da Dataprev adotam medidas técnicas e administrativas de
              proteção dos seus dados, aptas a proteger os dados pessoais de acessos não autorizados e de
              situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão.<p />

              O Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome e a Dataprev não se responsabilizam pelo acesso ao aplicativo por
              meio de computadores ou celulares inseguros.<p />

              A Política de Controle de Acesso aos dados do Cadastro Único está regulamentada pela Portaria
              nº 502, de 29 de novembro de 2017<p />

              <a target="_blank" rel="noreferrer" href="http://www.mds.gov.br/webarquivos/legislacao/cadastro_unico/portarias/2017/portaria_502_29112017.pdf">
              http://www.mds.gov.br/webarquivos/legislacao/cadastro_unico/portarias/2017/portaria_502_29112017.pdf</a><p />

              Os princípios de Segurança da Informação e Privacidade seguidos pela Dataprev podem ser
              consultados na &nbsp;
              <a target="_blank" rel="noreferrer" href="https://portal3.dataprev.gov.br/sites/default/files/arquivos/rs_cadm_011_2019_01.pdf">
                Política de Segurança da Informação (POSIC).
              </a><p />

              O Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome e a Dataprev comunicarão aos cidadãos a ocorrência de incidente de
              segurança que possam acarretar riscos ou dano relevantes.<p />
            </span><p /><p />

            <span className={styles.textTitle}>
              O serviço Aplicativo e site do CADASTRO ÚNICO utiliza cookies?
            </span><p />
            <span>
              Cookies são pequenos arquivos de texto enviados pelo site ao computador do usuário e que
              nele ficam armazenados, com informações relacionadas à navegação do site.<p />

              Por meio dos cookies, pequenas quantidades de informação são armazenadas pelo navegador
              do usuário para que nosso servidor possa lê-las posteriormente. Podem ser armazenados, por
              exemplo, dados sobre o dispositivo utilizado pelo usuário, bem como seu local e horário de
              acesso ao site.<p />

              É importante ressaltar que nem todo cookie contém dados pessoais do usuário, já que
              determinados tipos de cookies podem ser utilizados somente para que o serviço funcione
              corretamente.<p />

              As informações eventualmente armazenadas em cookies também são consideradas dados
              pessoais e todas as regras previstas nesta Política de Privacidade também são aplicáveis a eles.<p />
            </span>
            <p />

            <span className={styles.textTitle}>
              TERMO DE AUTORIZAÇÃO PARA ENVIO DE MENSAGENS (VIA CELULAR E E-MAIL)
            </span><p />
            <span>
              Com a concordância deste termo, declaro que o telefone e e-mail informados são de minha propriedade e autorizo o
              Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome a enviar mensagens por esses canais utilizando os dados e autorizações informados por mim
              no Aplicativo e site do CADASTRO ÚNICO, de acordo com as seguintes condições: <p />

              <strong>a.</strong> o envio de mensagens se dará somente para fins de implementação de políticas públicas e realização de
                  estudos e pesquisas, conforme previsto no Decreto nº 11.016, de 29 de março de 2022, que regulamenta o
                  Cadastro Único, e JAMAIS serão utilizadas para fins comerciais; <p />

                <strong>b.</strong> as mensagens sempre conterão descrição clara do remetente e darão a opção de se remover imediatamente do
                  recebimento de novas mensagens; <p />

                <strong>c.</strong> as mensagens se limitarão a textos e JAMAIS conterão links, endereços de e-mail, propagandas de terceiros,
                  arquivos anexos, solicitação de senha nem pedidos de autorização; <p />

                <strong>d.</strong> o serviço de envio de mensagens será prestado por prazo indeterminado, podendo ser cancelado a qualquer tempo sem aviso prévio,
                  sem prejuízo para minha pessoa ou ainda para o Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome e os seus operadores; <p />

                <strong>e.</strong> o Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome e os seus operadores não se responsabilizam por problemas nos serviços de celular e e-mail nem por
                  acessos de outras pessoas às mensagens recebidas por mim; <p />

                <strong>f.</strong> as dúvidas sobre o envio de mensagens podem ser esclarecidas pela Central de Atendimento do Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome,
                  pelo telefone 121 ou por meio eletrônico, no site: &nbsp;
                  <a target="_blank" rel="noreferrer" href="https://www.gov.br/mds/pt-br/acesso-a-informacao/participacao-social/fale-conosco">
                  https://www.gov.br/mds/pt-br/acesso-a-informacao/participacao-social/fale-conosco
                  </a>
                <p />
            </span>

            {stateTermoDeUso.ativarMensagem && <div>
                <Message
                  id="mensagem"
                  type="warning"
                  title={'Atenção'}
                  text={mensagem.MSG_CAD_UNICO_NAO_CADASTRADO}
                  className={styles.message}
                />
              </div>}

            <div className={styles.center}>
              {props.comeFromProtectedRoute && (
                <BrButton
                  id="botaoLiConcordo"
                  className={styles.buttonPrimario}
                  onClick={() => assinarTermo()}
                >
                  Li e concordo
                </BrButton>
              )}

              <BrButton
                id="botaoVoltar"
                className={styles.buttonSecundario}
                onClick={() => voltar()}
              >
                Voltar para o menu
              </BrButton>
            </div>
          </Card>
        }

        {/**
         * Mostrando mensagem para atualização do app quando a versão estiver desatualizada.
         */}
        {temTermoDeUsoAssinado === undefined && isAuthenticated && !temVersaoMinimaAceitavel && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgAlerta} alt="Imagem"/>
              <Message
                type={'warning'}
                text={
                  config.isCordova ? (
                    mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
                  ) : (
                    mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
                  )
                }
              />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => fecharMensagemAtualizacaoApp()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {/**
         * Mostrando mensagem de falta de comunicação com a API.
         */}
        {temTermoDeUsoAssinado === undefined && isAuthenticated && temVersaoMinimaAceitavel && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
              <Message
                type={'error'}
                text={mensagens.MSG_ERRO_COMUNICACAO_API}
              />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => logout()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}
      </div>
    </MainContainer>
  );
};

export default TermoDeUso;
